var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-rate"},[_c('h2',{staticClass:"l-rate-title"},[_vm._v("指读结果：")]),_c('div',{staticClass:"l-rate-container"},_vm._l((_vm.starList),function(item,index){return _c('img',{key:index,staticClass:"l-rate-star",attrs:{"src":item,"alt":""}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }